import React from "react";
import AccountVerification from "../../components/AccountVerification";

function VerifyAccount({ navigation, route }) {
  return (
    <AccountVerification
      userId={route.params.id}
      onSuccess={() => navigation.navigate("signin")}
      onClose={() => navigation.goBack()}
    />
  );
}

export default VerifyAccount;
